import Vue from "vue"
import config from '../../config'
import util from './util';

export default {
    get(zepplinCompanyId, params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/zepplin/companies/' + zepplinCompanyId, util.makeRequestConfig(params)).then((response) => response.json())
    },

    getList(params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/zepplin/companies', util.makeRequestConfig(params)).then((response) => response.json())
    },

    getCompanyCategories(params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/zepplin/companies/categories', util.makeRequestConfig(params)).then((response) => response.json())
    },

    updateCompany(zepplinCompanyId, body, params = {}) {
        return Vue.http.patch(config.apiBaseUrl + '/zepplin/companies/' + zepplinCompanyId, body, util.makeRequestConfig(params)).then((response) => response.json())
    },

    updateCompanyBasePoint(zepplinCompanyId, body, params = {}) {
        return Vue.http.patch(config.apiBaseUrl + '/zepplin/companies/' + zepplinCompanyId + '/base-point', body, util.makeRequestConfig(params)).then((response) => response.json())
    },

    getCompanyBrands(zepplinCompanyId, params = {}) {
        return Vue.http.get(`${config.apiBaseUrl}/zepplin/companies/${zepplinCompanyId}/brands`, util.makeRequestConfig(params)).then((response) => response.json())
    },

    getReportCompanies(params = {}) {
        return Vue.http.get(`${config.apiBaseUrl}/zepplin/reports/companies`, util.makeRequestConfig(params)).then((response) => response.json())
    },

    updateCompanyTax(zepplinCompanyTaxId, body, params = {}) {
        return Vue.http.patch(config.apiBaseUrl + '/zepplin/companies/taxes/' + zepplinCompanyTaxId, body, util.makeRequestConfig(params)).then((response) => response.json())
    },

    getBrandProductsByCompanyId(zepplinCompanyId, params = {}) {
        return Vue.http.get(`${config.apiBaseUrl}/zepplin/companies/brand-products/${zepplinCompanyId}`, util.makeRequestConfig(params)).then((response) => response.json())
    },

}
